import { render, staticRenderFns } from "./classroom_view.vue?vue&type=template&id=3ca29ad9&scoped=true&"
import script from "./classroom_view.vue?vue&type=script&lang=ts&"
export * from "./classroom_view.vue?vue&type=script&lang=ts&"
import style0 from "./classroom_view.vue?vue&type=style&index=0&id=3ca29ad9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca29ad9",
  null
  
)

export default component.exports